export default {
    state: {
        questionAnswer: [
            {
                question: 'Какая сумма вашего долга?',
                answers: [
                    '200 000 - 500 000 рублей',
                    '500 000 - 1 000 000 рублей',
                    '1 000 000 - 1 500 000 рублей',
                    'Более 1 500 000 рублей',
                ]
            },
            {
                question: 'Сколько времени вы не платите по кредитам?',
                answers: [
                    'До 3х месяцев',
                    'от 3 до 12 месяцев',
                    'Больше года',
                    'У меня нет просрочек',
                    'Другое'
                ]
            },
            // {
            //     question: 'Нужна рассрочка на услуги банкротства?',
            //     answers: [
            //         'Да',
            //         'Нет',
            //         'Еще не определился'
            //     ]
            // },
            {
                question: 'Как вам удобно получить рассчет?',
                answers: [
                    'WhatsApp',
                    'СМС',
                    'БЕСПЛАТНАЯ консультация по телефону – хочу узнать о скидках на услуги и рассрочке, которая сейчас действует',
                ]
            }
        ],
        data: [],
        step: 0,
        startPage: true,
        lastStep: false,
        quizThanks: false
    },
    getters: {
        getQuestions(state) {
            return state.questionAnswer
        },
        getStep(state) {
            return state.step
        },
        getLastStep(state) {
            return state.lastStep
        },
        getStartPage(state) {
            return state.startPage
        },
        getDataAnswer(state) {
            return state.data
        },
        isQuizThanks(state) {
            return state.quizThanks
        }
    },
    mutations: {
        changeStep(state, payload) {
            // if (state.step === 2 && state.data[2].answer === 'Другой регион') {
            //     alert('Мы не работаем с другими регионами!')
            //     return false
            // }
            // if (state.step === 7 && state.data[7].answer === 'Да') {
            //     alert('Сожалеем, но с текущими просрочками по кредитам банк откажет!')
            //     return false
            // }
            state.step += payload
        },
        set(state, payload) {
            state.data[state.step] = payload
            //console.log(state.data)
        },
        changeQuizThanks(state) {
            state.quizThanks = !state.quizThanks
        },
        changeStartPage(state) {
            state.startPage = !state.startPage
        }
    },
    actions: {
        prevNext({ state, commit }, value) {
            if (value < 0) {
                commit('changeStep', value)
            } else {
                if (state.step === state.questionAnswer.length - 1) {
                    state.lastStep = !state.lastStep
                    return false
                }
                if (!state.data[state.step]) {
                    alert('Выберите вариант ответа!')
                    return false
                }
                commit('changeStep', value)
            }

        },
        setData({ commit, state }, value) {
            commit('set', value)
        },
        viewOrQuizHideThanks({ commit }) {
            commit('changeQuizThanks')
        },
        viewOrHideStartPage({ state, commit }) {
            if (state.startPage) commit('changeStartPage')
        }
    }

};
